import axiosInstance from "auth/FetchInterceptor";
import {
  AIRLINE_API,
  GET_ALL_AIRLINE,
  CREATE_AIRLINE,
  UPDATE_AIRLINE,
  GET_ALL_AIRLINE_ACTIVE,
} from "constants/ApiConstant";
const AirlineService = {};

AirlineService.getAllAirline = function (data) {
  return axiosInstance.get(GET_ALL_AIRLINE, data);
};
AirlineService.getAllAirlineActive = function (data) {
  return axiosInstance.get(GET_ALL_AIRLINE_ACTIVE, data);
};
AirlineService.createAirline = function (data) {
  return axiosInstance.post(CREATE_AIRLINE, data);
};
AirlineService.updateAirline = function (data) {
  return axiosInstance.put(UPDATE_AIRLINE, data);
};
AirlineService.deleteAirline = function (id) {
  return axiosInstance.delete(`${AIRLINE_API}/${id}`, null);
};

export default AirlineService;
